import * as React from 'react';
import { Stack } from '../../../stack/stack';

export function SubmitActions({
  children,
}: {
  children: React.ReactNode | React.ReactNodeArray;
}) {
  return (
    <Stack
      direction="row"
      gap={8}
      style={{
        alignItems: 'center',
      }}
    >
      {children}
    </Stack>
  );
}
